module.exports = __webpack_public_path__ + "static/media/developer-picturemark-l.0eea0c16.svg";